





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';

@Component({ components: {} })
export default class ModalViewPDF extends Vue {
  @Prop({ default: '' }) url: string;
  @Prop({ default: '' }) title: string;

  showModal: boolean = true;
  loading: boolean = false;

  readonly loadingService = new LoadingService();

  created() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closedModal();
    }
  }

  mounted() {
    this.loadingService.showLoading();
    this.loading = true;
  }

  handleLoad() {
    this.loading = false;
    this.loadingService.hideLoading();
  }

  closedModal() {
    this.showModal = false;
    this.loadingService.hideLoading();
    this.loading = false;
    setTimeout(() => {
      this.showModal = true;
      this.$emit('cerrar');
    }, 100);
  }
}
